"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _ContactsListsApiClient = require("AudienceTargetingUIComponents/api/ContactsListsApiClient");

var FilterListsSelect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterListsSelect, _PureComponent);
  (0, _createClass2.default)(FilterListsSelect, null, [{
    key: "propTypes",
    get: function get() {
      return {
        labelConfig: _react.PropTypes.object,
        onBlur: _react.PropTypes.func.isRequired,
        onChange: _react.PropTypes.func.isRequired,
        placeholder: _react.PropTypes.string,
        value: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_immutable.List), _react.PropTypes.array])
      };
    }
  }]);

  function FilterListsSelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FilterListsSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterListsSelect).call(this, props));
    _this.state = {
      options: [],
      noResults: false,
      hasMissingAsset: false,
      input: '',
      isInputValid: true,
      offset: undefined
    };
    return _this;
  }

  (0, _createClass2.default)(FilterListsSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          labelConfig = _this$props.labelConfig,
          value = _this$props.value;
      var normalizedValue = value && _immutable.List.isList(value) ? value.toJS() : value;

      var missingText = labelConfig['missingList'] || _I18n.default.text(this.getLangKey('missingList'));

      var hasMissingAsset = this.state.hasMissingAsset;
      if (!normalizedValue) return;
      (0, _ContactsListsApiClient.fetchContactsListsByIds)(normalizedValue).catch(function () {}).then(function (results) {
        if (results) {
          var options = results.lists.map(function (result, idx) {
            if (result) {
              return {
                text: result.name,
                value: result.listId
              };
            } else {
              hasMissingAsset = true;
              return {
                text: missingText,
                value: normalizedValue[idx],
                tagUse: 'error'
              };
            }
          }).concat(_this2.state.options);

          _this2.setState({
            options: options,
            hasMissingAsset: hasMissingAsset
          });
        }
      }).done();
    }
  }, {
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "renderSelect",
    value: function renderSelect() {
      var _this3 = this;

      var _this$props2 = this.props,
          labelConfig = _this$props2.labelConfig,
          placeholder = _this$props2.placeholder,
          value = _this$props2.value,
          _onBlur = _this$props2.onBlur,
          onChange = _this$props2.onChange;

      var disabledText = labelConfig['noLists'] || _I18n.default.text(this.getLangKey('noLists'));

      var normalizedValue = value && value.toJS ? value.toJS() : value;
      return _react.default.createElement(_UITooltip.default, {
        title: disabledText,
        disabled: !this.state.noResults
      }, _react.default.createElement("div", null, _react.default.createElement(_UISelect.default, {
        disabled: this.state.noResults,
        error: !this.state.isInputValid,
        multiCollapseLimit: 4,
        options: this.state.options,
        onSelectedOptionChange: function onSelectedOptionChange(e) {
          var values = e.target.value;

          var missingText = labelConfig['missingList'] || _I18n.default.text(_this3.getLangKey('missingList'));

          var missingValues;

          if (_this3.state.hasMissingAsset) {
            missingValues = values.filter(function (val) {
              return val.text === missingText;
            });

            if (!missingValues.length) {
              _this3.setState({
                hasMissingAsset: false
              });
            }
          }

          _this3.setState({
            isInputValid: Boolean(values.length)
          });
        },
        loadOptions: function loadOptions(input, callback) {
          var pagination = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            offset: 0
          };
          var pageSize = 10;
          var nextOffset = pagination.offset + pageSize;
          var params = {
            offset: pagination.offset,
            count: pageSize
          };
          var query;

          if (pagination.hasMore !== undefined && !pagination.hasMore) {
            callback(null, {
              options: _this3.state.options,
              pagination: {
                hasMore: false,
                length: length,
                offset: nextOffset
              }
            });
            return;
          }

          if (input) {
            query = (0, _ContactsListsApiClient.searchContactLists)(_this3.state.offset, pageSize, input);
          } else {
            query = (0, _ContactsListsApiClient.fetchContactsLists)(params);
          }

          query.then(function (result) {
            var items = result.lists.map(function (list) {
              return {
                value: list.listId,
                text: list.name
              };
            });
            var hasNewSearch = _this3.state.input !== input;
            var hasMore = _this3.state.input ? 'hasMore' : 'has-more';

            if (!result[hasMore] && !input && items.length === 0) {
              _this3.setState({
                noResults: true
              });
            }

            _this3.setState({
              options: hasNewSearch ? items : _this3.state.options.concat(items),
              input: input,
              offset: _this3.state.input ? result.offset : undefined
            }, function () {
              callback(null, {
                options: _this3.state.options,
                pagination: {
                  hasMore: result[hasMore],
                  offset: nextOffset
                }
              });
            });
          });
        },
        multi: true,
        onBlur: function onBlur(e) {
          _this3.setState({
            isInputValid: Boolean(normalizedValue.length)
          });

          _onBlur(e);
        },
        onChange: onChange,
        placeholder: placeholder,
        value: normalizedValue
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIFormControl.default, {
        className: "targeting-option__input long"
      }, this.renderSelect());
    }
  }]);
  return FilterListsSelect;
}(_react.PureComponent);

exports.default = FilterListsSelect;
module.exports = exports.default;